



























import { computed, defineComponent, PropType } from "@vue/composition-api";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { getCostByCurrency } from "@/lib/moneyHelpers";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import CardCost from "@/components/CardCost";

export default defineComponent({
  name: "LevelItem",
  components: { BaseIconButton, CardCost, BaseIcon },
  props: {
    priceLevel: { type: Object as PropType<SubscriptionLevel>, required: true },
  },
  setup(props) {
    const cost = computed(() => {
      if (!props.priceLevel.pricePackage) return null;
      return getCostByCurrency(props.priceLevel.pricePackage);
    });
    const price = computed(() => cost.value?.cost ?? 0);
    const currencyCode = computed(() => cost.value?.currency);

    return {
      price,
      currencyCode,
    };
  },
});
